<div class="alert alert-info tw:w-full tw:text-center cursor-pointer" (click)="navBack()">Back to previous page</div>
<iframe [src]="secureLink | safe" frameborder="0" allowfullscreen="true" class="responsive-iframe" sandbox="allow-scripts allow-popups allow-same-origin"></iframe>
